export default __webpack_public_path__ + "static/media/GoodMannerWithYourParents_00.bf2f912c.png";